var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1TelephoneConference(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.28 51.36a4 4 0 01-4.61 6.53l4.61-6.53zM38 56.62c-5.67 0-10.92-2.93-13.36-7.47L21.11 51A18.92 18.92 0 0038 60.62 18.92 18.92 0 0054.89 51l-3.53-1.89c-2.44 4.58-7.69 7.51-13.36 7.51zm7.7 7.17a4 4 0 107-3.79l-7 3.79zM46.19 9H29.82A3.87 3.87 0 0026 12.81v30.37A3.87 3.87 0 0029.81 47h16.37A3.87 3.87 0 0050 43.19V12.82A3.87 3.87 0 0046.19 9zM30 43V13h16v30H30zm4 21a4 4 0 108 0h-8zm2-26.5a2 2 0 104 0 2 2 0 00-4 0zM25.18 65.42a4 4 0 005.41-1.63l-7-3.79a4 4 0 001.59 5.42zm-10.07-8.49a4 4 0 005.58 1l-4.61-6.53a4 4 0 00-.97 5.53z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Telephone_conference.177adf9d.svg";
export { SvgH1TelephoneConference as ReactComponent };